export default __webpack_public_path__ + "static/media/gallery_02.6fbf08b9.jpg";